"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const svg_icon_vue_1 = __importDefault(require("./svg-icon.vue"));
const req = require.context('./icons', false, /\.svg$/);
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);
function install(Vue) {
    Vue.component(svg_icon_vue_1.default.name, svg_icon_vue_1.default);
}
exports.default = install;
